module.exports = __webpack_public_path__ + "media/images/countrysquared/sa-a795bbccee643d4176322a7db88ad2d7.svg";